export default __webpack_public_path__ + "static/media/search.0761b92c.svg";